import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { Lottie } from 'lottie-react';
import { node, string } from 'prop-types';
import React from 'react';
import signInTapYes from './signInTapYes.json';

const Heading = ({ headline, subheading, type }) => (
  <Box component="section" sx={{ mb: '40px' }}>
    <div>
      <Typography sx={{ maxWidth: 330 }} gutterBottom variant="h5">
        {headline}
      </Typography>
      {type === 'app' ? (
        <>
          <Lottie
            src={signInTapYes}
            autoplay
            loop
            style={{ height: 150, width: 87, marginBottom: 8 }}
          />
          <Typography dangerouslySetInnerHTML={{ __html: subheading }} />
        </>
      ) : (
        <Typography
          variant={type === 'passkey' ? 'body1' : 'h5'}
          sx={{ color: '#8b98ab', fontWeight: 'normal' }}
        >
          {subheading}
        </Typography>
      )}
    </div>
  </Box>
);
Heading.propTypes = {
  headline: node.isRequired,
  subheading: node.isRequired,
  type: string.isRequired,
};

export default Heading;
